import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromClientDataStore from './state/client-data-store.reducer';

/* effects */
import { ClientDataStoreEffects } from './state/client-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* ClientDataStore State */
    StoreModule.forFeature(
      fromClientDataStore.featureKey,
      fromClientDataStore.reducer,
      { initialState: fromClientDataStore.initialState },
    ),
    EffectsModule.forFeature([ClientDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class ClientDataStoreModule {}
